import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список статей, их статус и мету
 */
export const selectArticleList = ({ articleList }: IApplicationState) => articleList;
